import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';

import * as yup from 'yup';
import { Done } from '@mui/icons-material';
import Button from '../Button';
import Form from '../Form';
import Input from '../Input';

import { useStyles } from './ForgotPasswordForm.styles';

const FormSchema = yup.object().shape({
  email: yup.string().required('Email is required').email('Invalid Email'),
});

// Per the Auth Hub no-enumeration contract this exact copy is shown for both
// success and failure of /auth/forgot-password — never reveal whether the
// email matched an account.
export const FORGOT_PASSWORD_NEUTRAL_CONFIRMATION =
  'If an account exists with this email, you\u2019ll receive a reset link shortly.';

export function ForgotPasswordForm({ onSubmit, isLoading, resetRequested }) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.contents}>
        <Typography component="h1" variant="h5">
          Forgot Password
        </Typography>
        <Form
          schema={FormSchema}
          className={classes.form}
          noValidate
          onSubmit={onSubmit}
          aria-label="forgot password form"
        >
          <Input
            className={classes.input}
            variant="filled"
            margin="normal"
            required
            fullWidth
            id="email"
            label="E-mail"
            name="email"
            placeholder="Type your email"
            autoComplete="email"
            autoFocus
            inputProps={{ 'data-testid': 'forgot-password:email-input' }}
          />
          <Box display="flex" justifyContent="center">
            {!resetRequested ? (
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                loading={isLoading}
                data-testid="forgot-password:button"
                aria-label="forgot password button"
              >
                Reset password
              </Button>
            ) : (
              <Box
                alignItems="flex-start"
                display="flex"
                marginTop={4}
                color="#4357EF"
                data-testid="forgot-password:neutral-confirmation"
              >
                <Done
                  style={{ fill: '#4357EF', marginRight: '8px', flexShrink: 0 }}
                />
                <Typography variant="body2" component="span">
                  {FORGOT_PASSWORD_NEUTRAL_CONFIRMATION}
                </Typography>
              </Box>
            )}
          </Box>
        </Form>
      </Box>
    </Box>
  );
}

ForgotPasswordForm.propTypes = {
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  backendError: PropTypes.string,
  handleClose: PropTypes.func,
  resetRequested: PropTypes.bool,
};
